const css = `._02Rx2W__hoverZone{width:100%;height:100%}._02Rx2W__hoverZone ._02Rx2W__hoverZoneRect{height:100%;position:absolute;overflow:visible}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"hoverZoneRect":"_02Rx2W__hoverZoneRect","hoverZone":"_02Rx2W__hoverZone"};
